import React from "react";
import useFetch from "@/lib/useFetch";
import { GlassCard, PageTitle, StatusBadge, EmptyState } from "@/components/lux";
import { money } from "@/lib/api";
import { ArrowDownToLine } from "lucide-react";
import { BscScanLink } from "@/components/DepositStatus";

export default function WithdrawalHistory() {
  const { data, loading } = useFetch("/user/withdrawals");
  const wds = data?.withdrawals || [];
  return (
    <div className="space-y-6">
      <PageTitle title="Withdrawal History" subtitle="All your payout requests" />
      <GlassCard className="p-6" data-testid="withdrawal-history-table">
        {loading ? <div className="skeleton h-40" /> : wds.length ? (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="text-left text-[var(--text-dim)]"><tr className="border-b border-white/10">
                <th className="py-3">ID</th><th className="py-3">Amount</th><th className="py-3">Fee</th><th className="py-3">Net</th><th className="py-3">Network</th><th className="py-3">Wallet</th><th className="py-3">Status</th><th className="py-3">Tx</th><th className="py-3">Date</th></tr></thead>
              <tbody>
                {wds.map((w) => (
                  <tr key={w.wd_id} className="row-hover border-b border-white/5">
                    <td className="py-3 text-white">{w.wd_id}</td>
                    <td className="py-3">${money(w.amount)}</td>
                    <td className="py-3 text-[var(--maroon)]">-${money(w.fee)}</td>
                    <td className="py-3 gold-text">${money(w.net)}</td>
                    <td className="py-3">{w.network}</td>
                    <td className="py-3 max-w-[140px] truncate text-[var(--text-dim)]" title={w.wallet_address}>{w.wallet_address}</td>
                    <td className="py-3"><StatusBadge status={w.status} /></td>
                    <td className="py-3" data-testid={`wd-tx-${w.wd_id}`}>{w.tx_hash ? <BscScanLink hash={w.tx_hash} /> : <span className="text-[var(--text-dim)]">—</span>}</td>
                    <td className="py-3 text-[var(--text-dim)]">{(w.created_at || "").slice(0, 10)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : <EmptyState icon={ArrowDownToLine} title="No withdrawals yet" />}
      </GlassCard>
    </div>
  );
}
